import React, { useEffect, useState } from "react";
import { Grid, Typography, Avatar, Button, Stack, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/Auth";
import DefaultImageProfile from "./profile-default.png";
import UserInputField from "./Fields/UserInputField";
import UserPhoneNumber from "./Fields/UserPhoneNumber";
import { separarNombreYApellidos } from "../../utils/icon/separarNombreApellido";
import {
  createUserProfile,
  getUserLoginLogsByUserId,
  getUserProfile,
} from "../../controllers/operaciones";
import { Spinner } from "../Loading/Spinner";
import MuiAlert from "@mui/material/Alert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TableLogs from "../Table/TableLogs";
import CountrySelect from "./Fields/CountrySelect";
import ConfiguracionObjetivosAprendizaje, {
} from "./Fields/ConfiguracionObjetivosAprendizaje";
import { Logout } from "@mui/icons-material";


export default function UserProfile() {
  const { user, setUser, logout } = useAuthContext();

  const [toastOpen, setToastOpen] = useState(false);
  const navigate = useNavigate();
  const [, setImage] = useState(DefaultImageProfile);
  const [logsLimit] = useState(15);
  const [userData, setUserData] = useState({
    name: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    cargo: "",
    RBD: "",
    colegio: "",
    pais: "",
    ciudad: "",
    especialidades: []

  });
  const [isLoading, setIsLoading] = useState(true);
  const [loginLogs, setLoginLogs] = useState([]);

  useEffect(() => {
    (async () => {
      if (user?.id) {
        setIsLoading(true);
        await handleLoadProfile();
        await handleLoadLoginLogs();
        setIsLoading(false);
      }
    })();
  }, [user?.id]);

  //Detecta el cambio en el Alert para despues de 3 seg cerrarlo
  useEffect(() => {
    if (toastOpen) {
      setTimeout(() => {
        setToastOpen(false);
      }, 3000);
    }
  }, [toastOpen]);

  const handleInputChange = (field) => (event) => {
    setUserData((prevData) => ({
      ...prevData,
      [field]: event.target ? event.target.value : event,
    }));
  };

  //Detecta cambios en el componente country en el input city
  const handleInputChangeCity = (city) => {
    setUserData((prevData) => ({
      ...prevData,
      ciudad: city,
    }));
  };

  //Detecta cambios en el componente country
  const handleInputChangePais = (pais) => {
    console.log("pais", pais);
    setUserData((prevData) => ({
      ...prevData,
      pais: pais,
    }));
  };

  //Guarda los cambios y envia el request para propagar cambios en la BD
  const handleGuardar = async () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setIsLoading(true);
    console.log("handleGuardar", { userData });
    const respuesta = await createUserProfile(user.id, userData);
    setUser((prev) => ({
      ...prev,
      name: respuesta.nombre + " " + respuesta.apellido,
      especialidades: respuesta.especialidades ?? userData.especialidades,
    }));
    setIsLoading(false);
    setToastOpen(true);
  };

  const handleCancelar = () => {
    navigate(-1);
  };

  //Carga la información de perfil del usuario
  const handleLoadProfile = async () => {
    const profile = await getUserProfile(user.id);
    if (profile) {
      const { nombre, apellido, tel, cargo, RBD, colegio, pais, ciudad } = profile;
      const { email } = user;
      setUserData({
        name: nombre,
        lastname: apellido,
        email,
        phoneNumber: tel,
        cargo,
        RBD,
        colegio,
        pais,
        ciudad,
        especialidades: profile.especialidades ?? []
      });
    } else {
      const result = separarNombreYApellidos(user.name);
      setUserData({
        name: result.nombre || "",
        lastname: result.apellidos || "",
        email: user.email || "",
        phoneNumber: "",
        cargo: "",
        RBD: "",
        colegio: "",
        pais: "",
        ciudad: "",
        especialidades: [],
      });
    }
    setImage(user.picture || DefaultImageProfile);
  };

  //Carga los logs de inicio de sesión del usuario
  const handleLoadLoginLogs = async () => {
    const logs = await getUserLoginLogsByUserId(user.id, logsLimit);
    console.log({ logs });
    setLoginLogs(logs);
  };

  // Obtener iniciales del usuario
  function getInitials(input) {
    if (!input) return "";
    const base = String(input).trim();

    // Si viene email, usa parte antes de @; si no, usa el string completo
    const name = base.includes("@") ? base.split("@")[0] : base;

    const parts = name.split(/\s+/).filter(Boolean);

    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  const handleClose = () => console.log("Prueba");
  ;


  const location = useLocation();

  useEffect(() => {
    const shouldScroll = location.state?.scrollToEspecialidades;

    if (!shouldScroll) return;

    let attempts = 0;
    const maxAttempts = 20;

    const tryScroll = () => {
      const element = document.getElementById("panel-especialidades");

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        navigate(location.pathname, { replace: true, state: {} });
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(tryScroll, 1500);
      }
    };

    tryScroll();
  }, [location, navigate]);

  return (
    <>
      {toastOpen && (
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setToastOpen(false)}
          severity="success"
        >
          ¡Sus datos fueron actualizados correctamente!
        </MuiAlert>
      )}
      {isLoading && <Spinner />}
      {!isLoading && (
        <Grid container spacing={2}>

          {/** Avatar y botón cerrar sesión */}
          <Grid
            item
            xs={12}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            m={8}
          >
            <Avatar
              src={(user)?.avatarUrl || undefined}
              alt={user?.name ?? user?.email ?? "user"}
              sx={{
                width: "100px !important",
                height: "100px !important",
                fontSize: "46px",
                fontWeight: "bold",
                color: "#336B87",
                bgcolor: "#90AFC5",
                mr: 1.5,
              }}
            >
              {!(user)?.avatarUrl ? getInitials(user?.name || user?.email) : null}
            </Avatar>
            <Stack direction="column" >
              <Typography fontFamily={"Montserrat"} color={"#336B87"} sx={{ fontWeight: 700, fontSize: "36px", mb: -0.5 }} > {user?.name}</Typography>


            </Stack>

            <Box px={1.5} pt={2} pb={1.5} sx={{ ml: "auto" }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  handleClose();
                  logout(user);
                }}
                startIcon={<Logout />}
                sx={{

                  borderRadius: 5,
                  width: "350px",
                  fontFamily: "Montserrat",
                  fontWeight: 700,
                  textTransform: "none",
                  bgcolor: "#fff",
                  border: "1px solid #ff0000ff",
                  color: "#ff0000ff",
                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: "#ff0000ff",
                    color: "#FFF",
                    boxShadow: "none",
                  },
                  "&:focus-visible": {
                    outline: "2px solid #F8AD0C",
                    outlineOffset: "2px",
                  },

                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    left: 8,
                    top: 8,
                    bottom: 8,
                    width: 4,
                    borderRadius: 2,
                    backgroundColor: "transparent",
                    transition: "background-color .15s ease",
                  },
                }}
              >
                Cerrar sesión
              </Button>
            </Box>
          </Grid>

          {/* Datos personales y Colegio */}
          <Grid container spacing={2}
            sx={{
              backgroundColor: "#F5F5F5",
              borderRadius: "8px",
              m: 2,
              p: 5
            }}>
            {/* Datos Personales */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                p: 2,

              }}
            >
              <Typography
                sx={{
                  mb: 2,
                  fontSize: "26px",
                  fontFamily: "Montserrat",
                  color: "#336B87",
                  fontWeight: "bold"
                }}
              >
                Datos Personales
              </Typography>

              <Grid container spacing={2} display={"Flex"} flexDirection={"column"}>
                <Grid item xs={12} md={6}>
                  <UserInputField
                    label="Nombre"
                    value={userData.name}
                    onChange={handleInputChange("name")}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <UserInputField
                    label="Apellido"
                    value={userData.lastname}
                    onChange={handleInputChange("lastname")}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <UserInputField
                    label="Email"
                    value={userData.email}
                    onChange={handleInputChange("email")}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <UserPhoneNumber
                    label="Número de celular"
                    value={userData.phoneNumber}
                    onChange={handleInputChange("phoneNumber")}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <UserInputField
                    label="Cargo"
                    value={userData.cargo}
                    onChange={handleInputChange("cargo")}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Datos del Colegio */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                p: 2,
              }}
            >
              <Typography
                sx={{
                  mb: 2,
                  fontSize: "26px",
                  fontFamily: "Montserrat",
                  color: "#336B87",
                  fontWeight: "bold"
                }}
              >
                Datos del Colegio
              </Typography>

              <Grid container spacing={2} display={"Flex"} flexDirection={"column"}>
                <Grid item xs={12} md={8}>
                  <UserInputField
                    label="RBD de la Escuela"
                    value={userData.RBD}
                    onChange={handleInputChange("RBD")}
                  />
                </Grid>

                <Grid item xs={12} md={8}>
                  <UserInputField
                    label="Nombre de la Escuela"
                    value={userData.colegio}
                    onChange={handleInputChange("colegio")}
                  />
                </Grid>

                <Grid item xs={12} md={8}>
                  <CountrySelect
                    label="País"
                    country={userData.pais}
                    city={userData.ciudad}
                    onPaisChange={handleInputChangePais}
                    onCityChange={handleInputChangeCity}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/**Mis accesos */}
          <Grid
            item
            xs={12}
            xl={12}
            md={12}
            sx={{
              m: 2,
              p: 5
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                mb: 2,
                fontSize: "24px",
                fontFamily: "Montserrat",
                color: "#336B87",
                fontWeight: "bold"

              }}
            >
              Mis Accesos
            </Typography>
            <TableLogs data={loginLogs} limit={logsLimit} />
          </Grid>


          {/**Configuraciones */}
          <Grid
            item
            id="panel-especialidades"
            xs={12}
            xl={12}
            md={12}
            sx={{
              m: 2,
              p: 5,
              scrollMarginTop: "100px",
            }}
          >
            <ConfiguracionObjetivosAprendizaje setUserData={setUserData} userEspecialidades={userData.especialidades} />
          </Grid>

          <Grid container spacing={2} justifyContent="right">
            <Grid item>
              <Stack spacing={2} direction="row">
                <Button
                  variant="contained"
                  onClick={handleCancelar}
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    fontWeight: 600,
                    backgroundColor: "#FFF",
                    borderRadius: "20px",
                    minWidth: "200px",
                    color: "#336B87",
                    border: "1px solid #336B87",
                    textTransform: "none",

                    "&:hover": {
                      backgroundColor: "#336B87",
                      color: "#FFF",
                      border: "1px solid #336B87",
                    },
                  }}
                >
                  Volver
                </Button>
                <Button
                  variant="contained"
                  onClick={handleGuardar}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    fontWeight: 600,
                    backgroundColor: "#336B87",
                    borderRadius: "20px",
                    minWidth: "200px",
                    color: "#FFF",
                    textTransform: "none",

                    "&:hover": {
                      backgroundColor: "#2da533ff",
                    },
                  }}

                >
                  Guardar
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
